module.exports = __webpack_public_path__ + "static2023-4-17/img/week_2.10f043ee.png";